import { z } from "zod";

export const ExportFormat = {
	CSV: "csv",
	PDF: "pdf",
} as const;

export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];

export const EXPORT_FORMATS = Object.values(ExportFormat) as readonly ExportFormat[];

export const exportFormatSchema = z.enum(ExportFormat);

export const CsvDelimiter = {
	COMMA: ",",
	SEMICOLON: ";",
	TAB: "\t",
} as const;

export type CsvDelimiter = (typeof CsvDelimiter)[keyof typeof CsvDelimiter];

export const CSV_DELIMITERS = Object.values(CsvDelimiter) as readonly CsvDelimiter[];
